import React from 'react';
import { PieChart, Pie, Cell, Tooltip,  ResponsiveContainer, LabelList, Label } from 'recharts';
import { Link, useLocation } from "react-router-dom";


const formattedData = (data) => {
    
    return data && data.length > 0 ? data.map(item => {
        let color;
        ////console.log(item.action_status)
        switch (item.action_status) {
        case 'Due to 30':
            color = '#05769D';
            break;
        case 'Overdue 30-60':
            color = '#F07167';
            break;
        case 'Overdue 0-30':
            color = '#FED4AE';
            break;
        case 'Overdue 60':
            color = "#FFA500";
            break;
        default:
            color = '#8884d8';
    }
        return { 
            name: item.action_status, 
            value: parseFloat(item.count), 
            color: color 
        };
    }) : [];
};

const ActionStatus = ({ height, data }) => {

    const newData = formattedData(data);
    console.log('ActionStatus Data:', data, " : ", newData);
    ////console.log('Height:', height);

    // Calculate safe dimensions for the chart
    const safeHeight = typeof height === 'string' ? 300 : Math.max(height, 200);
    const calculatedOuterRadius = Math.min(safeHeight / 3, 80);
    const calculatedInnerRadius = Math.max(calculatedOuterRadius - 30, 20);

    if (!data || data.length === 0) {
        return (
            <div
                style={{ height }}
                className="flex flex-col items-center justify-center"
            >
                <div className="text-center text-lg text-gray-600 mb-4">
                    No data available for Action Status
                </div>
                <Link
                    to="/risk"
                    className="px-4 py-2 bg-[#3b3b3b] text-white rounded-md hover:bg-[#0E5088]"
                >
                    Add Actions
                </Link>
            </div>
        );
    } 
    
    return (
        newData && newData.length > 0 ? <ResponsiveContainer width="100%" height={height} className="mt-4">
            <PieChart className="z-10">

                <Pie
                    data={newData}
                    cx="50%"
                    cy="50%"
                    outerRadius={calculatedOuterRadius}
                    innerRadius={calculatedInnerRadius}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {newData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <LabelList dataKey="name" position="outside" />
                    <Label
                        value="Due"
                        position="center"
                        style={{ fontSize: '20px', fontWeight: 'bold' }}
                    />
                </Pie>
                <Tooltip />
            </PieChart>
        </ResponsiveContainer> : <div className="flex items-center justify-center h-full">No actions available for this department. </div>
    );
};

export default ActionStatus;